import Carousel from 'react-bootstrap/Carousel';
import { NavLink } from 'react-router-dom';
import { trackBannerClick } from "../utils/dataUserpush";
function HomeCarousel({ carousel_data }) {
    return (
        <Carousel fade className='home_carousel' controls={carousel_data.length > 1 ? true : false} indicators={carousel_data.length > 1 ? true : false} >
            {
                carousel_data?.map((item) => {
                    const urlParts = item.url.split("/").filter(Boolean);
                    const lastPart = urlParts[urlParts.length - 1] || "Banner Item";
                    const formattedTitle = lastPart.replace(/[-_]/g, " ");
                    return (
                        <Carousel.Item key={item.carousel_id} >
                            <NavLink to={item.url}
                                onClick={() => trackBannerClick(formattedTitle)}
                            >
                                <img src={item.image_url} alt='' />
                            </NavLink>
                        </Carousel.Item>
                    )
                })
            }
        </Carousel>
    );
}

export default HomeCarousel;